module.exports = "# Esmeralda and Goober Opening Story\n\nYouTube: N0kawhcRfFc\n\n## Notes\nEsmeralda and Goober learn about methane and chase after another supervillain, the Blaster (2:11).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/sections/12_esOpeningStory/level3_opening.md
// module id = 1837
// module chunks = 2